export const productData = [
  { item: "New In" },
  { item: "Abayas" },
  { item: "Arabian clothing" },
  { item: "Cardigans & sweaters" },
  { item: "Dresses" },
  { item: "Hoodies & sweatshirts" },
  { item: "Jackets & coats" },
  { item: "Jeans" },
  { item: "Jumpsuits & playsuits" },
  { item: "Kimonos & capes" },
  { item: "Lingerie" },
  { item: "Socks & hosiery" },
  { item: "Sets" },
];

export const fitData = [
  { item: "Maternity" },
  { item: "Petite" },
  { item: "Plus size" },
  { item: "Tall" },
];

export const editData = [
  { item: "Modest" },
  { item: "Bridesmaids" },
  { item: "Holiday" },
  { item: "Occasionwear" },
  { item: "Partywear" },
  { item: "Streetwear" },
  { item: "Wedding dresses" },
  { item: "Wedding guest" },
  { item: "Workwear" },
];

export const brandData = [
  { item: "Ella" },
  { item: "Forever 21" },
  { item: "Ginger" },
  { item: "Mango" },
  { item: "Missguided" },
  { item: "New Look" },
  { item: "Jackets & coats" },
  { item: "River Island" },
  { item: "Threadz by Ajooni" },
  { item: "Trendyol" },
  { item: "Lingerie" },
  { item: "Haya’s Closet" },
  { item: "Guess" },
];

export const shoeData = [
  { item: "New In" },
  { item: "Boots" },
  { item: "Casual shoes" },
  { item: "Sandals & slides" },
  { item: "Sneakers" },
  { item: "Sports shoes" },
  { item: "View all" },
];

export const links = [
  { item: "New In" },
  { item: "Boots" },
  { item: "Casual shoes" },
  { item: "Sandals & slides" },
  { item: "Sneakers" },
  { item: "Sports shoes" },
  { item: "View all" },
];

export const checkedData = [
  {
    name:"Black"
  },
  {
    name:"pink"
  },
  {
    name:"red"
  },
  {
    name:"Brown"
  },
  {
    name:"Gray"
  },
  {
    name:"White"
  },
  {
    name:"yellow"
  },
  {
    name:"Green"
  },
  {
    name:"Black"
  },
  {
    name:"pink"
  },
  {
    name:"red"
  },
  {
    name:"Brown"
  },
  {
    name:"Gray"
  },
  {
    name:"White"
  },
  {
    name:"yellow"
  },
  {
    name:"Green"
  },
];

export const colorData = [
  {
    name:"Green",
    image:"/images/green.png"
  },
  {
    name:"Red",
    image:"/images/green.png"  },
  {
    name:"Pink",
    image:"/images/green.png" },
  {
    name:"Gray",
    image:"/images/green.png"
  },
  {
    name:"White",
    image:"/images/green.png"  },
  {
    name:"Black",
    image:"/images/green.png"
  },
  {
    name:"Brown",
    image:"/images/green.png"
  },
  {
    name:"Blue",
    image:"/images/green.png"
  },
  {
    name:"Yellow",
    image:"/images/green.png"
  },
  {
    name:"SkyBlue",
    image:"/images/green.png"  },
  {
    name:"Peach",
    image:"/images/green.png" },
  {
    name:"Orange",
    image:"/images/green.png"
  },
  {
    name:"Mango",
    image:"/images/green.png"  },
  {
    name:"Green",
    image:"/images/green.png"
  },
  {
    name:"Green",
    image:"/images/green.png"
  },
  {
    name:"Green",
    image:"/images/green.png"
  },
];
